import { render, staticRenderFns } from "./DropdownUpdateRates.vue?vue&type=template&id=b2ea153e&scoped=true"
import script from "./DropdownUpdateRates.vue?vue&type=script&lang=js"
export * from "./DropdownUpdateRates.vue?vue&type=script&lang=js"
import style0 from "./DropdownUpdateRates.vue?vue&type=style&index=0&id=b2ea153e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea153e",
  null
  
)

export default component.exports